import type { ListBuilderList } from '../../../types';
import { createInvoiceCartColumns } from '../columns';
import { CART_MOBILE_CARD_CONFIG, CART_REQUIRED_FIELDS } from '../shared';

/**
 * The invoice cart's line list. Same columns as the other two carts minus the
 * ordering-limit warning, which does not constrain a line that is already
 * billed.
 */
export const invoiceCartDefaultList: ListBuilderList = {
	id: 'invoice_cart_default',
	name: 'Invoice Items',
	type: 'default',
	active: true,
	sortOrder: 0,
	columns: createInvoiceCartColumns(),
	description: 'Lines on the invoice',
	requiredFields: CART_REQUIRED_FIELDS,
	mobileCardConfig: CART_MOBILE_CARD_CONFIG,
};
